import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { FullWidthContainer } from "~/components/FullWidthContainer";
import { Page } from "~/components/Page";
import { WorkflowHookTable } from "./components/WorkflowHookTable";

export function WorkflowHooksPage() {
  return (
    <Page title="Search Hooks">
      <FullWidthContainer>
        <DataStoreBreadcrumbs />
        <WorkflowHookTable />
      </FullWidthContainer>
    </Page>
  );
}
